/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AccountType {
  CONTRIBUTION_FBO = 'CONTRIBUTION_FBO',
  RESERVE_FBO = 'RESERVE_FBO',
}
